export const SET_IS_LOADING_AUTH = "SET_LOADING_AUTH/login-page";
export const SET_IS_LOGIN_AUTH = "SET_IS_LOGIN_AUTH/login-page";
export const SET_USER_DATA = "SET_USER_DATA/login-page";
export const SET_IS_EXPAND = "SET_IS_EXPAND/login-page";
